// src/components/Landing.js
export class LandingComponent {
  constructor(container, onNavigate) {
    this.container = container
    this.onNavigate = onNavigate || (() => {})
    this.render()
    this.attachEventListeners()
  }

render() {
  this.container.innerHTML = `
    <div class="landing-container with-scribbles">
      <div class="landing-scribble landing-scribble-1"></div>
      <div class="landing-scribble landing-scribble-2"></div>
      <div class="landing-content">
        <div class="landing-logo-wrapper">
          <img 
            src="/images/Songola_Light_Logo.png" 
            alt="Songola" 
            class="landing-logo light-logo"
          />
          <img 
            src="/images/Songola_Dark_Logo.png" 
            alt="Songola" 
            class="landing-logo dark-logo"
          />
        </div>
        
        <p class="landing-description">
        Get <strong>3 chances</strong> to guess lyrics to popular songs.<br/>
        Think you know the lyrics? Guess again.
        </p>
        
        <div class="landing-buttons">
        <button class="landing-btn subscribe-btn" id="subscribeBtn">
        Sign up
        </button>
        <button class="landing-btn login-btn" id="loginBtn">
        Log in
        </button>
        <button class="landing-btn play-btn" id="playBtn">
        Play
        </button>
        </div>
        
        <div class="landing-date">
          <div id="currentDate">${this.getCurrentDateString()}</div>
          <div class="landing-number">No. ${this.getDayNumber()}</div>
          <div class="landing-credit">Created by Songola Team</div>
        </div>
      </div>
    </div>
  `
}

  getCurrentDateString() {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date().toLocaleDateString('en-US', options)
  }

  getDayNumber() {
    // Calculate days since launch (January 1, 2024)
    const launchDate = new Date('2024-01-01')
    const today = new Date()
    const diffTime = Math.abs(today - launchDate)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
  }

    attachEventListeners() {
    const subscribeBtn = this.container.querySelector('#subscribeBtn')
    const loginBtn = this.container.querySelector('#loginBtn')
    const playBtn = this.container.querySelector('#playBtn')

    if (subscribeBtn) {
        subscribeBtn.addEventListener('click', () => {
        // Change this to navigate to auth instead of showing alert
        this.onNavigate('auth')
        })
    }

    if (loginBtn) {
        loginBtn.addEventListener('click', () => {
        this.onNavigate('auth')
        })
    }

    if (playBtn) {
        playBtn.addEventListener('click', () => {
        this.onNavigate('game')
        })
    }
    }

  destroy() {
    this.container.innerHTML = ''
  }
}